import { Component, Vue } from "vue-property-decorator";
import Template from "./SetPin.template.vue";

@Component({
  mixins: [Template],
  components: {}
})
export default class SetPinComponent extends Vue {
  public get pinModel() {
    return this.fieldType === "text" ? this.pin : this.maskedPin;
  }

  public set pinModel(pin: string) {
    this.fieldType === "text" ? (this.pin = pin) : (this.maskedPin = pin);
  }
  public disabledSave: boolean = true;
  protected fieldType = "password";
  protected symbol = "•";
  protected fullmask = false;

  private maskedPin: string = "";
  private pin: string = "";
  public save() {
    this.$emit("resolve", this.pin);
  }
  public close() {
    this.$emit("resolve", null);
  }

  public doPinMasking() {
    let plainpin: string = "";

    if (this.pin) {
      for (let i = 0; i < this.maskedPin!.length; i++) {
        if (this.maskedPin!.charAt(i) === this.symbol) {
          plainpin += this.pin!.charAt(i);
        } else {
          plainpin += this.maskedPin!.charAt(i);
        }
      }
    } else {
      plainpin = this.maskedPin;
    }

    const maskedstring = this.maskPin(plainpin!, this.fullmask);

    if (this.pin !== plainpin || this.maskedPin !== maskedstring) {
      this.pin = plainpin!;
      this.maskedPin = maskedstring;
    }
  }

  public maskPin(pinstring: string, fullmask: boolean) {
    const characterlimit = fullmask === true ? 0 : 1;
    let maskedstring = "";
    for (let i = 0; i < pinstring.length; i++) {
      if (i < pinstring.length - characterlimit) {
        maskedstring += this.symbol;
      } else {
        maskedstring += pinstring.charAt(i);
      }
    }
    return maskedstring;
  }

  public doOnInput(input: string) {
    this.fullmask = this.pin.length < input.length ? false : true;
    this.disabledSave = input.length < 5;
    this.doPinMasking();
  }

  public doOnBlur() {
    this.fullmask = true;
    this.doPinMasking();
  }

  public toggleInput() {
    this.fieldType = this.fieldType === "password" ? "text" : "password";
    this.maskedPin = this.pin;
    this.doOnBlur();
  }
}
